import {
  PanelCloseButton
} from "./chunk-W22Y52AU.js";
import {
  PanelMaximizeButton,
  panelDragHandle
} from "./chunk-7UHMFDJC.js";
import {
  Button
} from "./chunk-QXEA2YZ6.js";
import {
  Icon
} from "./chunk-7IEFGXFA.js";
import {
  GenieLogo_default
} from "./chunk-FU2RPPBJ.js";
import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/WorkspacePanel.tsx
import { useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
function WorkspacePanel({ title, titleContent, children, defaultOpen = true, open: controlledOpen, onOpenChange, onClose, className, actions, headerContent, embedded = false }) {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const open = embedded || (controlledOpen ?? internalOpen);
  const setOpen = (next) => {
    if (controlledOpen === void 0) setInternalOpen(next);
    onOpenChange?.(next);
  };
  return /* @__PURE__ */ jsxs("section", { "data-panel-collapsed": !open, "aria-label": title, className: cn("bg-popover text-popover-foreground border border-border rounded-lg w-[360px] max-w-full flex flex-col overflow-hidden shadow-float pointer-events-auto", open ? "min-h-[34px]" : "shrink-0", className, embedded && "!w-full !rounded-none !border-0 !bg-transparent !shadow-none", !open && "!flex-none"), children: [
    /* @__PURE__ */ jsxs("div", { hidden: embedded, ...embedded ? {} : panelDragHandle(title), className: embedded ? "hidden" : "flex items-center justify-between px-2 py-1 shrink-0 gap-2", children: [
      title === "Genie" && /* @__PURE__ */ jsx(GenieLogo_default, { "aria-hidden": "true", "data-genie-panel-icon": true, className: "h-4 w-4 shrink-0" }),
      titleContent ?? /* @__PURE__ */ jsx("p", { className: cn("text-sm font-normal truncate", headerContent ? "shrink-0" : "flex-1"), children: title }),
      headerContent && /* @__PURE__ */ jsx("div", { className: "min-w-0 flex-1", children: headerContent }),
      actions,
      !embedded && /* @__PURE__ */ jsx(PanelMaximizeButton, {}),
      onClose && /* @__PURE__ */ jsx(PanelCloseButton, { title, onClose }),
      /* @__PURE__ */ jsx(Button, { type: "button", variant: "ghost", size: "sm", "aria-label": `${open ? "Collapse" : "Expand"} ${title}`, "aria-expanded": open, onClick: () => setOpen(!open), className: "h-6 w-6 p-1 bg-muted rounded-[6px] hover:bg-accent", children: /* @__PURE__ */ jsx(Icon, { name: open ? "chevron-up" : "chevron-down", className: "h-4 w-4" }) })
    ] }),
    /* @__PURE__ */ jsx("div", { hidden: !open, className: cn("min-h-0 flex-1 overflow-auto", !open && "hidden"), children })
  ] });
}

export {
  WorkspacePanel
};
//# sourceMappingURL=chunk-KHWATL65.js.map